import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { VersionService } from '../../core/services/version.service';
import { TranslationService } from '../../services/translation.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  private versionService = inject(VersionService);
  readonly ts = inject(TranslationService);

  readonly currentYear = new Date().getFullYear();

  // Version loaded from Azure Blob Storage - NO FALLBACK
  readonly versionFileName = signal<string>('');
  readonly versionDisplayName = signal<string>(''); // Kurzer Name für Anzeige (z.B. "2026.01")
  readonly versionFileUrl = signal<string>('');
  readonly versionLoading = signal<boolean>(false);
  readonly versionError = signal<string | null>(null);

  ngOnInit(): void {
    this.loadVersionFromBlobStorage();
  }

  private loadVersionFromBlobStorage(): void {
    this.versionLoading.set(true);
    this.versionService.getCurrentVersionFileInfo().subscribe({
      next: (info: {
        version_file: string;
        version_content: string;
        latest_patch_version: string;
      }) => {
        // Speichere den vollständigen Dateinamen (z.B. "2026.01.00.html")
        this.versionFileName.set(info.version_file);

        // Verwende die vom Backend extrahierte höchste Patch-Version
        // z.B. "2026.01.03" wenn das die neueste Version im HTML ist
        this.versionDisplayName.set(info.latest_patch_version);

        // Erstelle URL zur HTML-Datei über API
        const blobUrl = `${environment.api.apiUrl}/api/app/releasenotes_portal/${info.version_file}`;
        this.versionFileUrl.set(blobUrl);

        this.versionLoading.set(false);
        this.versionError.set(null);
      },
      error: (error: Error) => {
        console.error('❌ Failed to load portal version:', error);
        this.versionLoading.set(false);
        this.versionError.set(error.message || 'Failed to load version');
        // NO FALLBACK - keep version empty to show error state
      },
    });
  }

  onOpenReleaseNotes(event: MouseEvent): void {
    event.preventDefault();
    const fileName = this.versionFileName();
    if (fileName) {
      void this.versionService.openReleaseNotesInNewTab(fileName);
    }
  }
}
